import { Link } from 'react-router';
import { useMemo } from 'react';
import { Grid } from 'antd';
import { useTheme } from 'styled-components';
import { IconSvg } from 'shared/icon';
import { useAppSelector } from 'store/hooks';
import { selectUserConfigMenuCollapse } from 'app/userPreferences/selectors';
import { getSidebarSizes } from 'utils/styledHelpers';
import { StyledLogoWrapper } from 'app/layout/components/Layout.styled';

const { useBreakpoint } = Grid;
const sidebarSizes = getSidebarSizes();

export interface LogoProps {
  collapsedWidth?: string,
  width?: string
}

const Logo = ({ collapsedWidth = sidebarSizes.collapsedWidth, width = sidebarSizes.width }:LogoProps) => {
  const screens = useBreakpoint();
  const isSmallDevice = !screens.sm;

  const menuCollapse = useAppSelector(selectUserConfigMenuCollapse);

  const { colors } = useTheme();

  const collapsed = useMemo(() => (!isSmallDevice ? menuCollapse : true), [menuCollapse, isSmallDevice]);
  const menuWidth = useMemo(() => (collapsed ? collapsedWidth : width), [collapsed, collapsedWidth, width]);

  return (
    <StyledLogoWrapper $menuWidth={menuWidth} $menuClose={collapsed}>
      <Link to="/">
        {(!collapsed
          ? <IconSvg icon="WordMarksIcon" color={colors.blue} width="100%" height="100%" />
          : <IconSvg icon="MonogramIcon" color={colors.blue} width="100%" height="100%" />
        )}
      </Link>
    </StyledLogoWrapper>
  );
};

export default Logo;
